'use client';
// VX L4-10 — 오류 경계. 본문·동작은 KdRouteError(킥커 보드 판 · Sentry · reset) 한 곳에 있다.
import KdRouteError from '@/components/shell/KdRouteError';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <KdRouteError error={error} reset={reset} title="글을 불러오지 못했습니다" back={{ href: '/blog', label: '블로그 목록' }} />;
}
